import Vue from "vue";
import VueRouter from "vue-router";

import studentRoutes from "./student";
import store from "../store";

import Home from "@/views/pages/Home";
import Pricing from "@/views/pages/Pricing";
import Blog from "@/views/pages/Blog";
import BlogPost from "@/views/pages/BlogPost";
import Contact from "@/views/pages/Contact";
import NotFound from "@/views/pages/Error";
import Login from "@/views/auth/Login.vue";
import Register from "@/views/auth/Register.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "", //pages
    component: () =>
      import(/* webpackChunkName: "pages" */ "../views/Home.vue"),
    children: [
      {
        path: "",
        name: "Home",
        component: Home
      },
      {
        path: "/pricing",
        name: "Pricing",
        component: Pricing
      },
      {
        path: "/blog",
        name: "Blog",
        component: Blog
      },
      {
        path: "/blog/:slug",
        name: "BlogPost",
        component: BlogPost
      },
      {
        path: "/contact",
        name: "Contact",
        component: Contact
      }
    ]
  },
  {
    path: "", //templateAuth
    component: () =>
      import(
        /* webpackChunkName: "authtemplate" */ "../views/auth/Template.vue"
      ),
    children: [
      {
        path: "/login",
        name: "Login",
        component: Login,
        meta: {
          guest: true
        }
      },
      {
        path: "/register",
        name: "Register",
        component: Register,
        meta: {
          guest: true
        }
      }
    ]
  },
  {
    path: "",
    component: () => import(/* webpackChunkName: "student" */ "../views/Home"),
    children: [
      ...studentRoutes,
      {
        path: "*",
        name: "NotFound",
        component: NotFound
      }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  linkActiveClass: "active",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  let user = store.state.auth.user;
  let userFromLocal = localStorage.getItem("user");

  if (user == null) {
    user = JSON.parse(userFromLocal);
    store.commit("auth/setUser", user);
  }

  if (userFromLocal == null) {
    next({
      path: "/login",
      params: { nextUrl: to.fullPath }
    });
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (user == null) {
      next({
        path: "/login",
        params: { nextUrl: to.fullPath }
      });
    } else {
      next();
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    if (user == null) {
      next();
    } else {
      next({ name: "Dashboard" });
    }
  } else {
    next();
  }
});

export default router;
